module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration014.845febf7.webp";